var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"agreement no-trans"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detials.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }